import { get, post } from '@/utils/ajax'

// 获取上课提醒 学生
export const getTeachingRemind = () => get('/edu/zone/teaching/class/remind')
/**
 * 获取上课列表
 * @param {*} type student teacher
 * @returns 【】
 */
export const getTeachingList = (type = 'student') => get(`/edu/zone/teaching/class/${type}/list`)
// 获取上课记录
export const getTeachingHistory = ({ page, limit }) =>
  get(`/edu/zone/teaching/record/list?page=${page}&limit=${limit}`)
// 获取课程包列表
export const getCoursePackageList = (page = 1, topicId = 'all') => {
  const params = {
    pacakgeEntryType: 0,
    topicType: 'all',
    topicId,
    tagId: 'all',
    page,
    limit: 999
  }
  return get(`/edu/zone/lesson/offical/packages`, params)
}
// 获取课程列表
export const getCourseList = package_id => {
  const params = {
    package_id,
    page: 1,
    limit: 100
  }
  return get('/edu/zone/lesson/offical/lessons', params)
}
// 创建上课教室
export const createTeachingRoom = params =>
  post('/edu/zone/teaching/start', params, { ignoreMsg: true })

// 根据课程id查课程详情
export const getCourseDetailById = id => get(`/edu/zone/lesson/offical/lessons/${id}/view`)

// 根据自定义备课ID查询课程详情
export const getCourseDetailByCustomId = id => get(`/edu/zone/lesson/customized/lessons/${id}`)

// 获取课程详情里的超级课件
export const getSuperCourseDetail = (id, teaching) => {
  console.log('teaching', teaching)
  const url = teaching
    ? `/edu/zone/teaching/fetch/lesson/complex/course?teachingRecordId=${id}`
    : `/edu/zone/lesson/offical/lesson/complex/course/fetch?lessonId=${id}`
  return get(url)
}

// 结束上课
export const endTeaching = teachingRecordId => post('/edu/zone/teaching/end', { teachingRecordId })

// 查看作品提交情况
export const getCatWorksList = params => get('/edu/zone/teaching/work/list', params)

// 上课中切换课程
export const changeCourseTeaching = params => post('/edu/zone/teaching/change/lesson', params)

// 学生获取上课提醒
export const getTeachingNotice = () => get('/edu/zone/teaching/class/remind')
// 学生获取课堂指令
export const getTeachingCommand = teachingRecordId =>
  get('/edu/zone/teaching/fetch/command?teachingRecordId=' + teachingRecordId)

// 学生进入教室
export const studentInClass = teachingRecordId =>
  post('/edu/zone/teaching/student/in/class?teachingRecordId=' + teachingRecordId)

// 学生退出教室
export const studentOutClass = teachingRecordId =>
  post('/edu/zone/teaching/student/out/class?teachingRecordId=' + teachingRecordId)

// 学生开始创作
export const startCreation = params => post('/edu/zone/teaching/student/creation', params)
// 学生开始互动
export const startIntract = params => post('/edu/zone/teaching/student/interaction', params)

// 获取上课记录
export const getCourseRecordList = params => get(`/edu/zone/applicant/list`, params)
